import {Row} from "antd";
import styled from "styled-components";

export const OrderInformationContainer = styled(Row)`
    width: 100%;
    padding: 20px 0;
    margin-bottom: 20px;
    border-bottom: 1px dashed #c6c5c5;
`;
